module.exports = __webpack_public_path__ + "static/jfr-ddd811ac9bca560e3fa91446f71dfc76.png";